module.exports = __webpack_public_path__ + "assets/images/EUR200.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR200.png
// module id = 1367
// module chunks = 1